// We are using a JavaScript config file instead of the jsconfig.json or the .env file. JavaScript allows us to write code and comments during config.
const cloudfrontConfig = {
  cloudfrontBaseUrl: process.env.REACT_APP_ENV === 'DEV' ? 'https://d3b4eha2p5xyri.cloudfront.net' : process.env.REACT_APP_ENV === 'PROD' ? 'https://d18p1d69bdic7h.cloudfront.net' : 'https://d1qhp6j4t32f8y.cloudfront.net'
}

export default cloudfrontConfig;